#import "../fragments/AutomationFields.graphql"

mutation CancelBroadcast($id: ID!) {
  cancelBroadcast(id: $id) {
    ...AutomationFields
  }
}
